import { createFileRoute } from "@tanstack/react-router";
import { GiftCardBrandDirectory } from "@/components/gift-cards/brand-directory";
import { GiftCardError, GiftCardSkeleton } from "@/components/gift-cards/shared";
import { giftCardCatalogQuery, giftCardMeta } from "@/lib/gift-cards";

export const Route = createFileRoute("/_site/gift-cards/")({
  validateSearch: (search: Record<string, unknown>) => ({ page: Number.isSafeInteger(Number(search.page)) && Number(search.page) > 0 ? Number(search.page) : undefined }),
  loader: ({ context }) => context.queryClient.ensureQueryData(giftCardCatalogQuery),
  head: () => giftCardMeta(),
  pendingComponent: GiftCardSkeleton,
  errorComponent: GiftCardError,
  notFoundComponent: GiftCardError,
  component: GiftCardBrandDirectory,
});
